import { rtkApi } from "../../../shared/api/rtkApi";
import { CareerBackInterfacesDTODirectionDirectionDto } from "../../../shared/ApiContract/data-contracts";

const directionsApi = rtkApi.injectEndpoints({
    endpoints: (build) => ({
        getDirections: build.query<CareerBackInterfacesDTODirectionDirectionDto[], void>({
            query: () => ({
                url: `direction`,
            }),
        }),
        getTeams: build.query<CareerBackInterfacesDTODirectionDirectionDto | null, string>({
            query: (id) => ({
                url: `direction/${id}`,
            }),
        }),
    }),
});

export const { useGetDirectionsQuery, useGetTeamsQuery } = directionsApi;
